import {
  Home, Settings, Zap, Brain, Users, Shield, Database, Bell,
  CreditCard, Key, Code, SlidersHorizontal, HardDrive,
  BarChart3, Wrench, Server, Layout, Flag, Puzzle, Layers, User
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type UserRole = 'superuser' | 'admin' | 'employee' | 'tenant_admin' | 'consumer'

export interface NavItem {
  label: string
  href: string
  icon?: LucideIcon
  end?: boolean
}

export interface NavSection {
  id: string
  label: string
  icon: LucideIcon
  href?: string
  items?: NavItem[]
  roles: UserRole[]
  status?: 'active' | 'deferred'
  requireActiveTenant?: boolean
  dividerBefore?: string
}

export const navigation: NavSection[] = [
  {
    id: 'home',
    label: 'Home Dashboard',
    icon: Home,
    href: '/',
    roles: ['superuser', 'admin', 'employee', 'tenant_admin'],
  },
  {
    id: 'my-profile',
    label: 'My Profile',
    icon: User,
    href: '/admin/my-profile',
    roles: ['superuser', 'admin', 'employee'],
  },
  {
    id: 'settings',
    label: 'Platform Settings',
    icon: Settings,
    roles: ['superuser', 'admin', 'employee', 'tenant_admin'],
    requireActiveTenant: true,
    items: [
      { label: 'Account & Billing', href: '/settings/account', icon: CreditCard },
      { label: 'Team & Permissions', href: '/settings/team', icon: Users },
      { label: 'API & Integrations', href: '/settings/integrations', icon: Key },
      { label: 'Compliance Overview', href: '/settings/compliance', icon: Shield },
      { label: 'Tenant Calibration', href: '/settings/calibration', icon: SlidersHorizontal },
      { label: 'Storage & Governance', href: '/settings/governance', icon: Database },
      { label: 'Notifications', href: '/settings/notifications', icon: Bell },
    ],
  },
  {
    id: 'engage',
    label: 'Engage',
    icon: Zap,
    roles: ['superuser', 'admin', 'employee', 'tenant_admin'],
    requireActiveTenant: true,
    dividerBefore: 'PRODUCTS',
    items: [
      { label: 'Dashboard', href: '/engage/dashboard', icon: Layout },
      { label: 'Persona Library', href: '/engage/personas', icon: Users },
      { label: 'Skill Suite', href: '/engage/skills', icon: Brain },
      { label: 'Channels & Deployment', href: '/engage/channels', icon: Puzzle },
      { label: 'Customer Intelligence', href: '/engage/intelligence', icon: BarChart3 },
      { label: 'Analytics & Reports', href: '/engage/analytics', icon: BarChart3 },
      { label: 'Persona Instances', href: '/tenant/engage/persona-engine-instances', icon: Layers },
    ],
  },
  {
    id: 'memory',
    label: 'Memory',
    icon: Database,
    roles: ['superuser', 'admin', 'employee', 'tenant_admin'],
    requireActiveTenant: true,
    items: [
      { label: 'Overview', href: '/tenant/memory', icon: Layout },
      { label: 'Configuration', href: '/tenant/memory/config', icon: SlidersHorizontal },
      { label: 'Data Sovereignty', href: '/tenant/memory/sovereignty', icon: Shield },
    ],
  },
  {
    id: 'coach',
    label: 'Coach',
    icon: Brain,
    roles: ['superuser', 'admin', 'employee', 'tenant_admin'],
    status: 'deferred',
    items: [
      { label: 'Dashboard', href: '/coach/dashboard', icon: Layout },
      { label: 'Agent Profiles', href: '/coach/agents', icon: Users },
      { label: 'Skill Development', href: '/coach/skills', icon: Brain },
      { label: 'Manager View', href: '/coach/manager', icon: BarChart3 },
    ],
  },
  {
    id: 'admin',
    label: 'System Admin',
    icon: Wrench,
    roles: ['superuser', 'admin', 'employee'],
    dividerBefore: 'INTERNAL',
    items: [
      { label: 'Tenant Operations', href: '/admin/tenants', icon: Server },
      { label: 'User Management', href: '/admin/users', icon: Users },
      { label: 'Testing & Quality', href: '/admin/testing', icon: Code },
      { label: 'Model & Pipeline', href: '/admin/models', icon: Brain },
      { label: 'Platform Analytics', href: '/admin/analytics', icon: BarChart3 },
      { label: 'Compliance Admin', href: '/admin/compliance', icon: Shield },
      { label: 'Infrastructure & Ops', href: '/admin/ops', icon: HardDrive },
      { label: 'Content & Config', href: '/admin/config', icon: Flag },
      { label: 'Memory Admin', href: '/employee/memory', icon: Database },
      { label: 'Persona Engine', href: '/admin/persona-engine', icon: Brain },
      { label: 'Internal Tools', href: '/admin/internal', icon: Wrench },
    ],
  },
]
